import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetCardNumList() {
  return maintainRequest({
    url: `/user/maintenanceMan/card/getCardNumList`,
  });
}
